import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useConfigurationStore } from '@store/configurationStore';
import type { ParsedEquipment } from '@t/equipmentOffering.types';

export const useEquipmentSelection = (onConfirm: () => void) => {
  const { selectedEquipment, selectEquipment, updateEquipmentQuantity } = useConfigurationStore(
    useShallow((s) => ({
      selectedEquipment: s.selectedEquipment,
      selectEquipment: s.selectEquipment,
      updateEquipmentQuantity: s.updateEquipmentQuantity,
    }))
  );
  const [showError, setShowError] = useState(false);

  const handleSelect = (equipment: ParsedEquipment) => {
    selectEquipment(equipment.id);
    setShowError(false);
  };

  const handleQuantityChange = (equipmentId: string, quantity: number) => {
    updateEquipmentQuantity(equipmentId, quantity);
    setShowError(false);
  };

  const handleConfirm = () => {
    if (!selectedEquipment) {
      setShowError(true);
      return;
    }
    onConfirm();
  };

  return { selectedEquipment, showError, handleSelect, handleQuantityChange, handleConfirm };
};
